import { gql } from '@apollo/client';
import { DealItemSaleItemMinimalFragment } from './DealItemSaleItemMinimalFragment';
import { DealItemSaleItemVariantFragment } from './DealItemSaleItemVariantFragment';
import { DealItemConfigurationFragment } from 'graphql/Deal/fragments/DealItemConfigurationFragment';
import { FieldValueFragment } from 'graphql/FieldValue/fragments/FieldValueFragment';
/**
 * @fragment DealItemFragment
 * @since 1.0.0
 */
export const DealItemFragment = gql `
  fragment DealItemFragment on DealItem {
    id
    quantity
    price
    createdAt
    updatedAt
    proposed
    initiallyProposed
    alternativeTo
    date

    item {
      ...DealItemSaleItemMinimalFragment
    }

    variant {
      ...DealItemSaleItemVariantFragment
    }

    options {
      ...DealItemConfigurationFragment
    }

    packages {
      ...DealItemConfigurationFragment
    }

    fieldValues {
      ...FieldValueFragment
    }
  }

  ${DealItemSaleItemMinimalFragment}
  ${DealItemSaleItemVariantFragment}
  ${DealItemConfigurationFragment}
  ${FieldValueFragment}
`;
